import { ReactNode } from 'react';

interface InfoSectionProps {
  title: string;
  children: ReactNode;
}

export function InfoSection({ title, children }: InfoSectionProps) {
  return (
    <div>
      <h3
        style={{
          fontSize: '1rem',
          fontWeight: 600,
          color: '#47331F',
          marginBottom: '0.75rem',
        }}
      >
        {title}
      </h3>
      {children}
    </div>
  );
}

interface InfoCardProps {
  children: ReactNode;
  variant?: 'default' | 'success' | 'error';
}

export function InfoCard({ children, variant = 'default' }: InfoCardProps) {
  const variantStyles = {
    default: {
      background: 'rgba(239, 235, 229, 0.5)',
      border: 'none',
    },
    success: {
      background: 'rgba(16, 185, 129, 0.1)',
      border: '1px solid rgba(16, 185, 129, 0.3)',
    },
    error: {
      background: 'rgba(239, 68, 68, 0.1)',
      border: '1px solid rgba(239, 68, 68, 0.3)',
    },
  };

  return (
    <div
      style={{
        padding: '1rem',
        borderRadius: '6px',
        ...variantStyles[variant],
      }}
    >
      {children}
    </div>
  );
}

interface InfoGridProps {
  items: Array<{ label: string; value: string | number | null | undefined }>;
}

export function InfoGrid({ items }: InfoGridProps) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '120px 1fr',
        gap: '0.5rem',
        fontSize: '0.875rem',
      }}
    >
      {items.map((item, i) => (
        <div key={i} style={{ display: 'contents' }}>
          <div style={{ fontWeight: 500 }}>{item.label}:</div>
          <div>{item.value ?? '—'}</div>
        </div>
      ))}
    </div>
  );
}
